import {
  BUSINESS_PROVIDER,
  SITE_ORIGIN,
  getAreaServed,
  localBusinessSchema,
} from '../utils/businessSchema';
import site from '../content/siteContent.json';
import {useLanguage} from '../i18n/Language';
import {localizeSchema} from './Seo';

const SERVICES = site.serviceCategories.map(({ title, ...service }) => ({
  ...service,
  name: title,
}));

const SEOSchema = () => {
  const {language}=useLanguage();
  const graph = {
    '@context': 'https://schema.org',
    '@graph': [
      localBusinessSchema,
      {
        '@type': 'WebSite',
        '@id': `${SITE_ORIGIN}/#website`,
        url: `${SITE_ORIGIN}/`,
        name: 'VVPSS Taxi Services',
        publisher: BUSINESS_PROVIDER,
        inLanguage: 'en-IN',
      },
      ...SERVICES.map(({ id, ...service }) => ({
        '@type': 'Service',
        '@id': `${SITE_ORIGIN}/#${id}`,
        ...service,
        provider: BUSINESS_PROVIDER,
        areaServed: getAreaServed(),
      })),
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(localizeSchema(graph,language)).replace(/</g, '\\u003c') }}
    />
  );
};

export default SEOSchema;
